import styled from 'styled-components'

export const Content = styled.p`
  ${({ font }) => font && `font-family: ${font};`}
  ${({ color }) => color && `color: ${color};`}
  font-size: 14px;
  line-height: 18px;
  min-height: 18px;
`
